// Texto do erro de uma solicitação para o modal de detalhes (TXM-655).
//
// `mensagem_erro` vem da central-rpas e, quando o RPA falha, chega como o repr cru de um dicionário
// Python, ex.: PesquisaError: {'error_name': 'PesquisaError', 'error_message': 'Pesquisa recusada ...'}
// Para o usuário interessa só o `error_message`; o texto original continua disponível como detalhe
// técnico. Mensagens que não seguem esse formato (ex.: "HTTP 503 da central-rpas: ...") passam como estão.

const ERROR_MESSAGE = /["']error_message["']\s*:\s*(?:'([^']*)'|"([^"]*)")/;

/**
 * @param {string|null|undefined} bruta mensagem_erro como veio da API
 * @returns {{ legivel: string, tecnico: string|null }} `tecnico` só existe quando difere do legível
 */
export function descreverErro(bruta) {
  const texto = typeof bruta === "string" ? bruta.trim() : "";
  if (!texto) return { legivel: "", tecnico: null };

  const m = ERROR_MESSAGE.exec(texto);
  const extraida = (m?.[1] ?? m?.[2] ?? "").trim();
  if (!extraida || extraida === texto) return { legivel: texto, tecnico: null };
  return { legivel: extraida, tecnico: texto };
}
